import queryString from 'query-string';

export const print = () => window.print();

export const refresh = query => {
  if (!query) {
    window.location.reload();
  }

  const existingQuery = queryString.parse(window.location.search);
  const newQuery = { ...existingQuery, ...query };

  window.location.search = queryString.stringify(newQuery);
};

export const copyContentToClipboard = el => {
  const range = document.createRange();
  range.selectNodeContents(el);

  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
  selection.removeAllRanges();
};

export const copyValueToClipboard = input => {
  input.select();
  document.execCommand('copy');
  input.blur();
};

export const openWindow = href =>
  window.open(
    href,
    'mywin',
    'left=200,top=200,width=1000,height=500,toolbar=1,resizable=0'
  );

export const scrollTo = to => {
  document.body.scrollTop = to;
  document.documentElement.scrollTop = to;
};

export const scrollToTop = () => scrollTo(0);

export const isHidden = el =>
  !el || (el.offsetWidth === 0 && el.offsetHeight === 0);

export const isVisible = el => !isHidden(el);
export const handleStopPropagation = e => e.stopPropagation();
